module.exports = __webpack_public_path__ + "img/Talal_Said.ae561aa2.png";